/* Just Brilliant desktop purchase disclosure; mobile uses the product sheet. */
(() => {
  if (customElements.get('jb-inline-shop')) return;
  customElements.define('jb-inline-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.cardPrice = this.closest('product-card')?.querySelector('.product-card-info > .price');
      if (this.cardPrice) {
        this.originalPrice = this.cardPrice.innerHTML;
        const syncPrice = () => {
          const price = this.querySelector('.product-price-container .price');
          if (price && this.cardPrice.innerHTML !== price.innerHTML) this.cardPrice.innerHTML = price.innerHTML;
        };
        this.priceObserver = new MutationObserver(syncPrice);
        this.priceObserver.observe(this, { childList: true, subtree: true, characterData: true });
        syncPrice();
      }
      this.querySelector('.jb-inline-close')?.addEventListener('click', () => this.close(), { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }, { signal });
      window.addEventListener('resize', () => {
        if (!matchMedia('(min-width: 1025px)').matches) this.close(false);
      }, { signal, passive: true });
      if (this.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.style.overflow = 'hidden';
        this.motion = this.animate([
          { height: '0px', opacity: 0 },
          { height: `${this.getBoundingClientRect().height}px`, opacity: 1 }
        ], { duration: 220, easing: 'cubic-bezier(.22,.61,.36,1)' });
        this.motion.finished.then(() => {
          if (!this.closing) this.style.overflow = '';
        }).catch(() => {});
      }
    }
    close(restoreFocus = true) {
      if (this.closing && restoreFocus) return;
      this.motion?.cancel();
      const trigger = this.trigger;
      const finish = () => {
        this.closest('product-card')?.classList.remove('jb-card-shopping');
        trigger?.setAttribute('aria-expanded', 'false');
        this.remove();
        if (restoreFocus && trigger?.isConnected) trigger.focus({ preventScroll: true });
      };
      if (!restoreFocus || !this.animate || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      this.closing = true;
      this.inert = true;
      this.style.overflow = 'hidden';
      this.motion = this.animate([
        { height: `${this.getBoundingClientRect().height}px`, opacity: 1 },
        { height: '0px', opacity: 0 }
      ], { duration: 180, easing: 'cubic-bezier(.22,.61,.36,1)' });
      this.motion.finished.then(finish).catch(() => {});
    }
    disconnectedCallback() {
      this.priceObserver?.disconnect();
      if (this.cardPrice && this.originalPrice !== undefined) this.cardPrice.innerHTML = this.originalPrice;
      this.motion?.cancel();
      this.abort?.abort();
      this.abort = null;
      this.closest('product-card')?.classList.remove('jb-card-shopping');
      this.trigger?.setAttribute('aria-expanded', 'false');
    }
  });
})();
